// @ts-nocheck

import { Component, OnInit, Input } from '@angular/core';
import { Rates, TimestampedRates } from '../model';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-graphs',
  templateUrl: './graphs.component.html',
  styleUrls: ['./graphs.component.css']
})

export class GraphsComponent implements OnInit {

  // Coinbase colours
  color = {
    white: "#ffffff",
    //lightGray: "#909ca9", // 144 156 169
    lightBWGray: "#aaaaaa",
    lightGray: "#f2f6f9", // 242 246 249
    gray: "#728aad", // 114 138 173
    darkGray: "#4e5b6b", // 78 91 107
    blue: "#3485da", // 52 133 218 // TBR
    darkBlue: "#045cca", // 4 92 202
    green: "#82bc48", // 130 188 72 // HEK
    yellow: "#ffa718", // 255 167 24 // RND
    purple: "#6471b1", // 100 113 177
    chartFillAlpha: "42"
  }

  rates: TimestampedRates[] = []

  hekChart = null
  tbrChart = null
  rndChart = null
  combinedChart = null

  @Input()
  showTimePicker = true

  constructor(public db: AngularFireDatabase, public auth: AngularFireAuth) {
  }

  ngOnInit() {
    this.createCharts()

    // Latest rates
    this.db.object("averageRatesInUsd/latest").valueChanges().map(values => {
      return new Rates(values["HEK"], values["TBR"], values["RND"])
    }).subscribe(rates => {
      document.getElementById("HEKTitle").innerHTML = "HEK = " + rates.HEK.toFixed(5) + " USD"
      document.getElementById("TBRTitle").innerHTML = "TBR = " + rates.TBR.toFixed(5) + " USD"
      document.getElementById("RNDTitle").innerHTML = "RND = " + rates.RND.toFixed(5) + " USD"
    })

    // Historical chart data
    this.db.list<TimestampedRates>("averageRatesInUsd").stateChanges().subscribe(action => {
      if (action.type == 'child_added') {
        let timestampString = action.payload.key
        if (timestampString != 'latest') {
          let timestamp = parseInt(timestampString)
          let rate = new TimestampedRates(timestamp, action.payload.val())
          this.rates.push(rate)
          this.addChartRate(rate)
        }
      }
    })
  }

  // Menu

  selectedMenuItem = 0

  menuItems = [
    { id: 0, title: "30m" },
    { id: 1, title: "1h" },
    { id: 2, title: "3h" },
    { id: 3, title: "6h" },
    { id: 4, title: "All" },
  ]

  menuClicked(menuItem) {
    this.selectedMenuItem = menuItem.id

    switch (menuItem.id) {
      case 0:
        this.minChartTimestamp = this.currentTimestamp() - this.milisecondsIn.minute * 30
        break
      case 1:
        this.minChartTimestamp = this.currentTimestamp() - this.milisecondsIn.hour
        break
      case 2:
        this.minChartTimestamp = this.currentTimestamp() - this.milisecondsIn.hour * 3
        break
      case 3:
        this.minChartTimestamp = this.currentTimestamp() - this.milisecondsIn.hour * 6
        break
      case 4:
        this.minChartTimestamp = 0
        break
    }
    this.reloadChartData()
  }

  // Time

  milisecondsIn = {
    minute: 60 * 1000,
    hour: 3600 * 1000,
    day: 86400 * 1000
  }

  currentTimestamp() {
    return new Date().getTime() // getTime() returns time in milliseconds
  }

  // Updates

  minChartTimestamp: number = 0

  reloadChartData() {
    this.setChartRates(this.rates)
  }

  // Main method for setting new data
  setChartRates(rates: TimestampedRates[]) {
    this.removeAllChartData()
    this.addChartRatesAfterTimestamp(rates, this.minChartTimestamp)
  }

  // Main method for adding new data
  addChartRatesAfterTimestamp(rates: TimestampedRates[], minTimestamp: number) {
    rates.forEach((rate) => {
      if (rate.timestamp >= minTimestamp) {
        this.addChartRate(rate)
      }
    });
  }

  // Main method for adding new data
  addChartRate(rate: TimestampedRates) {
    this.addChartData(this.hekChart, rate.timestamp, rate.rates.HEK)
    this.addChartData(this.tbrChart, rate.timestamp, rate.rates.TBR)
    this.addChartData(this.rndChart, rate.timestamp, rate.rates.RND)
    this.addCombinedChartRate(this.combinedChart, rate)
  }

  addChartData(chart, timestamp, value) {
    chart.data.labels.push(this.chartDateString(timestamp));
    chart.data.datasets.forEach((dataset) => {
      dataset.data.push(value);
    });
    chart.update();
  }

  addCombinedChartRate(chart: Chart, rate: TimestampedRates) {
    chart.data.labels.push(this.chartDateString(rate.timestamp));
    chart.data.datasets[0].data.push(rate.rates.HEK)
    chart.data.datasets[1].data.push(rate.rates.TBR)
    chart.data.datasets[2].data.push(rate.rates.RND)
    chart.update();
  }


  removeAllChartData() {
    this.removeChartData(this.hekChart)
    this.removeChartData(this.tbrChart)
    this.removeChartData(this.rndChart)
    this.removeChartData(this.combinedChart)
  }

  removeChartData(chart) {
    chart.data.labels.length = 0
    chart.data.datasets.forEach((dataset) => {
      dataset.data.length = 0
    });
    chart.update();
  }

  removeLastChartData(chart) {
    chart.data.labels.pop();
    chart.data.datasets.forEach((dataset) => {
      dataset.data.pop();
    });
    chart.update();
  }


  chartDateString(unix_timestamp) {
    // Create a new JavaScript Date object based on the timestamp
    var date = new Date(unix_timestamp);
    var hours = "0" + date.getHours();
    var minutes = "0" + date.getMinutes();
    var seconds = "0" + date.getSeconds();
    // Will display time in 10:30:23 format
    var formattedTime = hours.substr(-2) + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
    return formattedTime
  }

  // Colours

  chartFillColor(color) {
    return this.colorWithAlpha(color, this.color.chartFillAlpha)
  }

  colorWithAlpha(color, alpha) {
    return color + alpha
  }

  // Chart

  createCharts() {
    var hekTimestamps = []
    var tbrTimestamps = []
    var rndimestamps = []
    var hekValues = []
    var tbrValues = []
    var rndValues = []

    var hekContext = document.getElementById("HEKChart")
    var hekDataset = this.newDataset(hekValues, this.color.green, this.chartFillColor(this.color.green))
    var hekChart = this.newChart(hekContext, "HEK / USD", hekTimestamps, hekDataset)
    this.hekChart = hekChart

    var tbrContext = document.getElementById("TBRChart")
    var tbrDataset = this.newDataset(tbrValues, this.color.blue, this.chartFillColor(this.color.blue))
    var tbrChart = this.newChart(tbrContext, "TBR / USD", tbrTimestamps, tbrDataset)
    this.tbrChart = tbrChart

    var rndContext = document.getElementById("RNDChart")
    var rndDataset = this.newDataset(rndValues, this.color.yellow, this.chartFillColor(this.color.yellow))
    var rndChart = this.newChart(rndContext, "RND / USD", rndimestamps, rndDataset)
    this.rndChart = rndChart

    var hekCombinedDataset = this.newCombinedDataset("HEK", [], this.color.green)
    var tbrCombinedDataset = this.newCombinedDataset("TBR", [], this.color.blue)
    var rndCombinedDataset = this.newCombinedDataset("RND", [], this.color.yellow)
    var combinedDatasets = [hekCombinedDataset, tbrCombinedDataset, rndCombinedDataset]
    var combinedContext = document.getElementById("CombinedChart")
    var combinedChart = this.newCombinedChart(combinedContext, [], combinedDatasets)
    this.combinedChart = combinedChart

    // Sample data
    // var r: TimestampedRates[] = []
    // r.push(new TimestampedRates(this.currentTimestamp() - this.secondsIn.hour * 10, new Rates(8,4,3)))
    // r.push(new TimestampedRates(this.currentTimestamp() - this.secondsIn.hour * 5, new Rates(14,9,5)))
    // r.push(new TimestampedRates(this.currentTimestamp() - this.secondsIn.hour * 2, new Rates(4,7,10)))
    // r.push(new TimestampedRates(this.currentTimestamp() - this.secondsIn.minute * 45, new Rates(2,5,8)))
    // r.push(new TimestampedRates(this.currentTimestamp() - this.secondsIn.minute * 10, new Rates(6,3,12)))
    // this.rates = r

    this.reloadChartData()
  }

  newDataset(yValues, lineColor, fillColor) {
    return {
      data: yValues,
      pointRadius: 0,
      lineTension: 0.1,
      borderWidth: 2,
      borderJoinStyle: "bevel",
      borderColor: lineColor,
      backgroundColor: fillColor,
      fill: true
    }
  }

  newChart(context, yLabel, xValues, dataset) {
    return new Chart(context, {
      type: 'line',
      data: {
        labels: xValues,
        datasets: [dataset]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          // datasets.label
          display: false
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [{
            display: true,
            gridLines: {
              display: false,
              color: this.color.lightGray
            },
            scaleLabel: {
              display: true
            }
          }],
          yAxes: [{
            display: true,
            gridLines: {
              display: true,
              color: this.color.lightGray
            },
            scaleLabel: {
              display: true,
              labelString: yLabel
            }
          }]
        }
      }
    })
  }

  // Combined chart

  newCombinedDataset(label, yValues, lineColor) {
    return {
      label: label,
      data: yValues,
      pointRadius: 0,
      lineTension: 0.1,
      borderWidth: 2,
      borderJoinStyle: "bevel",
      borderColor: lineColor,
      fill: false
    }
  }

  newCombinedChart(context, xValues, datasets) {
    return new Chart(context, {
      type: 'line',
      data: {
        labels: xValues,
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [{
            display: true,
            gridLines: {
              display: true,
              color: this.color.lightGray
            }
          }],
          yAxes: [{
            display: true,
            gridLines: {
              display: true,
              color: this.color.lightGray
            },
            scaleLabel: {
              display: true,
              labelString: 'Value in USD'
            }
          }]
        }
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/graphs/graphs.component.ts